import { render, staticRenderFns } from "./XcalacocoBookingDetail.vue?vue&type=template&id=1438d389&scoped=true&"
import script from "./XcalacocoBookingDetail.vue?vue&type=script&lang=js&"
export * from "./XcalacocoBookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./XcalacocoBookingDetail.vue?vue&type=style&index=0&id=1438d389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1438d389",
  null
  
)

export default component.exports